$('.accordion-header').on('click', function () {

    if ($(this).hasClass('expanded')) {
        $(this).attr('aria-expanded', 'false').removeClass('expanded');
    }
    else {
        $(this).attr('aria-expanded', 'true').addClass('expanded');
    }

    var target = $(this).data('target');
    $('#' + target).toggleClass('show');

});